/* eslint-disable react/no-danger */
import Cookies from 'js-cookie'
import React, { useEffect, useRef, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

import { sanitize } from '../../logic/core/sanitize'
import { useGoogleTagManager } from '../../logic/hook/google-tag-manager'
import { pushPageVisited, pushButtonClicked } from '../../logic/utils/google-tag-manager/google-tag-manager'

export const AppContainer = ({ translations, configuration }) => {
  const [areCookiesDisabled, setAreCookiesDisabled] = useState(JSON.parse(localStorage.getItem('areCookiesDisabled')))
  const loaded = useGoogleTagManager(
    configuration?.apiKey?.googleTagManagerKey,
    areCookiesDisabled === null ? true : areCookiesDisabled
  )
  const buttonRef = useRef(null)

  const setCookies = (areCookiesDisabled) => () => {
    setAreCookiesDisabled(areCookiesDisabled)
    localStorage.setItem('areCookiesDisabled', areCookiesDisabled)
  }

  useEffect(() => {
    if (areCookiesDisabled === null) {
      // eslint-disable-next-line no-unused-expressions
      buttonRef.current?.click()
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (loaded) {
      const sessionIdInitial = uuidv4()

      Cookies.set('sessionIdInitial', sessionIdInitial)
      pushPageVisited(translations.title, sessionIdInitial)
    }
  }, [loaded, translations.title])

  return (
    <>
      <div className='layout'>
        <div className='layout--top'>
          <div className='formbox'>
            <div className='formbox--scrollable no_mCustomScrollbar' data-mcs-theme='minimal-dark'>
              <div className='in'>
                <h1 dangerouslySetInnerHTML={sanitize(translations.title, true)} />

                <p className='text-left' dangerouslySetInnerHTML={sanitize(translations.info, true)} />

                <p className='text-left' dangerouslySetInnerHTML={sanitize(translations.onlineForm, true)} />

                <div className='space-30' />

                <div className='infosteps'>
                  <div className='infostep--item'>
                    <div className='infostep--img'>
                      <img
                        src='/welcome/public/img/icons/OP-pas.svg'
                        alt={sanitize(translations.infoStep.idPassport)}
                        width={133}
                        height={69}
                      />
                    </div>
                    <div
                      className='infostep--txt'
                      dangerouslySetInnerHTML={sanitize(translations.infoStep.idPassport, true)}
                    />
                  </div>
                  <div className='infostep--item'>
                    <div className='infostep--img'>
                      <img
                        src='/welcome/public/img/icons/Phone-mail.svg'
                        alt={sanitize(translations.infoStep.phoneMail)}
                        width={51}
                        height={80}
                      />
                    </div>
                    <div
                      className='infostep--txt'
                      dangerouslySetInnerHTML={sanitize(translations.infoStep.phoneMail, true)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='formbox--bottom'>
              <div className='in'>
                <div className='row'>
                  <div className='form-group offset-sm-6 offset-sm-6 col-sm-6 col-xs-12'>
                    <a
                      className='button__next'
                      href='/web/'
                      onClick={() => {
                        Cookies.set('referrer', Cookies.get('referrerFromWeb') || document.referrer)
                        Cookies.remove('referrerFromWeb')

                        Cookies.set('welcome_pass', 'ok')
                        pushButtonClicked('continue')
                      }}
                    >
                      {translations.button.submit}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='layout--bottom'>
        <div className='layout--bottom--container layout--flex-center'>
          <div className='layout--bottom--logo'>
            <a href='https://www.jtbank.cz/' title='J&amp;T Banka' target='_blank' rel='noopener noreferrer'>
              <img src='/welcome/public/img/logo/jat-banka.svg' alt='J&amp;T Banka' width={118} height={17} />
            </a>
          </div>
        </div>
      </div>

      <button
        type='button'
        style={{ display: 'none' }}
        data-toggle='modal'
        data-target='#cookieModal'
        ref={buttonRef}
      />
      <div
        className='modal fade'
        id='cookieModal'
        tabIndex='-1'
        role='dialog'
        aria-labelledby='cookieModalTitle'
        aria-hidden='true'
        data-backdrop='static'
      >
        <div className='modal-dialog modal-lg modal-dialog-centered' role='document'>
          <div className='modal-content px-4 rounded-0'>
            <div className='modal-header center'>
              <h5 className='modal-title nowrap' id='cookieModalTitle' style={{ marginTop: '10px' }}>
                {translations.cookiesModal.title}
              </h5>
            </div>
            <div className='modal-body'>
              <div className='pb-2' style={{ whiteSpace: 'pre-line' }}>
                {translations.cookiesModal.description}
              </div>
              <a
                target='_blank'
                rel='noopener noreferrer'
                href={translations.cookiesModal.moreInfoLink}
                style={{ color: '#0074cc' }}
              >
                {translations.cookiesModal.moreInfo}
              </a>
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-outline-primary rounded-0 py-2'
                data-dismiss='modal'
                onClick={setCookies(true)}
              >
                {translations.button.declineCookies}
              </button>
              <button
                type='button'
                className='btn btn-primary rounded-0 py-2 ml-3'
                data-dismiss='modal'
                onClick={setCookies(false)}
              >
                {translations.button.acceptCookies}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
